export default "__VITE_ASSET__DgQz$h5V__"